export const AUTHORISED_DISTRIBUTORS = 'ad';
export const PARALLEL_IMPORTERS = 'pi';
